import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import NavList from "./nav/nav-list";
import AlertDialog from "./dialog/confirm/confirm-dialog";
import AuthService from "../service/auth-service";
import VisitService from "../service/visit-service";

const Layout = ({
  showServiceMenu,
  setShowServiceMenu,
  showPersonalMenu,
  setShowPersonalMenu,
}) => {
  //帳號權證失效 dialog（任一 API 回 401 都會觸發；同時間多個 401 只顯示一次）
  const [showAuthExpired, setShowAuthExpired] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onAuthExpired = () => setShowAuthExpired(true);
    window.addEventListener("auth-expired", onAuthExpired);
    return () => window.removeEventListener("auth-expired", onAuthExpired);
  }, []);

  //進站打點：每次切換前台頁面記錄一筆（後台 /admin 不經過 MainLayout，不會被計入）
  useEffect(() => {
    VisitService.track(location.pathname);
  }, [location.pathname]);

  const handleAuthExpiredConfirm = () => {
    AuthService.logout();
    setShowAuthExpired(false);
    navigate("/");
  };

  return (
    <>
      <NavList
        showServiceMenu={showServiceMenu}
        setShowServiceMenu={setShowServiceMenu}
        showPersonalMenu={showPersonalMenu}
        setShowPersonalMenu={setShowPersonalMenu}
      />
      {/* Outlet 會自動在 Layout 下的其他 Route 標籤內自動轉換 */}
      <Outlet />

      <AlertDialog
        open={showAuthExpired}
        title="登入已逾期"
        message="為了保護您的帳號安全，登入狀態會定期到期，</br>請重新登入以繼續體驗元辰雲閣！"
        confirmTxt="我知道了"
        image="/images/ic-default-lock.png"
        onClose={handleAuthExpiredConfirm}
        onSuccess={handleAuthExpiredConfirm}
      />
    </>
  );
};

export default Layout;
